import { render } from "./TramiteFinalizados.vue?vue&type=template&id=8f821c7a&scoped=true"
import script from "./TramiteFinalizados.vue?vue&type=script&lang=js"
export * from "./TramiteFinalizados.vue?vue&type=script&lang=js"

import "./TramiteFinalizados.vue?vue&type=style&index=0&id=8f821c7a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f821c7a"]])

export default __exports__